WiseMetering.Views.ShowNextbittDataConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/nextbitt_data/show',
    title: () => i18next.t('modal.title.integration_configurations.show')

    // edit: function() {
    //     new WiseMetering.Views.EditNextbittDataConfiguration({ model: this.model });
    // }
});
